module.exports = __webpack_public_path__ + "media/img/ceo-phuc-2-07a6fb4c.jpg";